import { ChangeDetectorRef, Directive, DoCheck, ElementRef, inject, OnInit, Self, OnDestroy, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'input,textarea,nz-date-picker,nz-select,nz-textarea-count',
  standalone: true
})
export class HasValueDirective implements DoCheck, OnInit, OnDestroy {
  @Optional() @Self() public ngControl: NgControl = inject(NgControl);
  private element: ElementRef = inject(ElementRef);
  private chageDetector: ChangeDetectorRef  = inject(ChangeDetectorRef);
  private controlSubscription!: Subscription | undefined;

  ngOnInit(): void {
    this.controlSubscription =  this.ngControl.valueChanges?.subscribe({
      next: (value) => {
        this.addOrRemoveClass(value);
      }
    })


    this.chageDetector.detectChanges();
  }

  ngDoCheck(): void {
    this.addOrRemoveClass(this.ngControl.value);
  }

  ngOnDestroy(): void {
    this.controlSubscription?.unsubscribe();
  }

  addOrRemoveClass(value: string | number){
    const container = this.element.nativeElement.closest('nz-textarea-count');

    (container)
    ? (value) ? container.classList.add('ng-hasvalue')
              :container.classList.remove('ng-hasvalue')
    : (value) || (value === 0)
    ? (this.element?.nativeElement).classList.add('ng-hasvalue')
    : (this.element?.nativeElement).classList.remove('ng-hasvalue');


  }
}
